import { graphql } from '../../generated';

export const GET_ACTIVITY = graphql(`
  query getActivity($id: ID!) {
    activity(id: $id) {
      id

      ... on ActivityWithItemsInterface {
        items {
          total
          seat {
            name
            venueSection {
              name
            }
          }
          productVariant {
            sku
            description
            physical
          }
          product {
            id
            name
            ... on MerchProduct {
              artist
              productType
              color
            }
            ... on Event {
              happeningFrom
              venue {
                name
                address {
                  city
                }
              }
            }
          }
        }
      }
    }
  }
`);
